import { LitElement, html, css, unsafeCSS } from 'lit';
import classnames from 'classnames';

import request from '../../utils/request/request';
import Logger from '../../utils/logger/logger';
import config from '../../../shared/config/config';

import styles from './promo-apps-collection.component.scss';


export class PromoAppsCollection extends LitElement {
  static properties = {
    collectionId: { type: String },
    data: { type: String },
    apps: { state: true },
    isWebView: { type: String },
    showDeeplinks: { type: Boolean },
    articleSlug: { type: String },
  };

  static styles = css`${unsafeCSS(styles.toString())}`;

  // analogue of the componentDidMount
  async connectedCallback() {
    super.connectedCallback();

    if (this.data) {
      this.apps = JSON.parse(this.data);

      return;
    }

    // it is only needed when you insert a collection in the text editor to load data dynamically
    try {
      const { apps } = await request.get(`/api/promo-apps-collections/${this.collectionId}`);
      this.apps = apps;
      this.requestUpdate();
    } catch (error) {
      Logger.catchError('Apps collection fetch have failed', error);
    }
  }

  render() {
    const isWebView = this.isWebView !== undefined;

    const showDeeplinks = this.showDeeplinks || false;
    const blogArticleSlugFallback = window.location.pathname?.split('/').filter(Boolean)?.at(-1); // to handle trailing slash

    const articleSlug = this.articleSlug || blogArticleSlugFallback;

    const getDetailsUrl = (app) => {
      const deepLink = new URL('setappdiscovery://open_collection');
      // used in desktop app for analytics event send and open application details page
      deepLink.searchParams.append('app_id', app.id);
      deepLink.searchParams.append('app_name', app.name);
      deepLink.searchParams.append('start_point', 'blog-article');
      deepLink.searchParams.append('blog_article_url', articleSlug);

      return showDeeplinks ? deepLink.toString()  : app.detailsUrl;
    };

    return html`
      <section class="promo-collection">
        ${this.apps?.map((app) => html`
            <a
              class="${classnames('promo-collection__app', { 'promo-collection__app_web-view': isWebView })}"
              href=${getDetailsUrl(app)}
            >
              <img
                class="${classnames('promo-collection__app-icon', { 'promo-collection__app-icon_rounded': !app.platforms.includes('Mac') })}"
                src="${app.icon.src}"
                srcset="${app.icon.srcSet}"
                alt="${app.icon.alt}"
                width="80"
                height="80"
              />
              <div class="promo-collection__app-content">
                <div class="promo-collection__app-title">${isWebView ? app.name : app.shortDescription}</div>
                <div class="promo-collection__app-description">${isWebView ? app.shortDescription : app.name}</div>
                <div class="promo-collection__app-details">
                  ${app.rating ? html`
                    <svg class="promo-collection__app-rating-icon" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M6.425 4.94A4.01 4.01 0 0 0 6 6.74V11c0 1.1.895 2 2 2h3.562c.856 0 1.617-.54 1.893-1.35l1.259-3.7c.442-1.29-.523-2.64-1.894-2.64H10V1.99a.99.99 0 0 0-1.87-.45l-1.705 3.4zM2.5 5.31A1.5 1.5 0 0 0 1 6.81v4.69a1.499 1.499 0 1 0 3 0V6.81a1.5 1.5 0 0 0-1.5-1.5z" opacity=".5" fill-rule="evenodd"/></svg>
                    <div class="promo-collection__app-rating">${app.rating}%</div>
                  ` : undefined}
                  ${app.platforms}
                </div>
                <div class="preview-app-button">
                  <svg class="preview-app-button__icon" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="m8 3.5c3 0 5.3333333 1.5 7 4.5-1.6666667 3-4 4.5-7 4.5s-5.33333333-1.5-7-4.5c1.66666667-3 4-4.5 7-4.5zm0 2.5c-1.1045695 0-2 .8954305-2 2s.8954305 2 2 2 2-.8954305 2-2-.8954305-2-2-2z" fill-rule="evenodd" opacity=".5"/></svg>
                  <span class="preview-app-button__text">View app</span>
                </div>
              </div>
            </a>
          `)}
      </section>
    `;
  }
}

const definePromoAppsCollectionElement = () => {
  customElements.define(config.get('customElements').promoAppsCollection, PromoAppsCollection);
};

export default definePromoAppsCollectionElement;
